export { default } from 'ember-can/services/abilities';
